enum StripePaymentType {
    AFFIRM = 'Affirm',
    AFTERPAY_CLEARPAY = 'Afterpay',
    KLARNA = 'Klarna',
    ZIP = 'Zip',
}

const paymentTypeMap: Record<string, StripePaymentType> = {
    affirm: StripePaymentType.AFFIRM,
    afterpay_clearpay: StripePaymentType.AFTERPAY_CLEARPAY,
    klarna: StripePaymentType.KLARNA,
    zip: StripePaymentType.ZIP,
};

export const getStripePaymentTypeName = (
    stripePaymentType: string | null,
): StripePaymentType | null => {
    if (!stripePaymentType) {
        return null;
    }

    const paymentType = paymentTypeMap[stripePaymentType];
    if (!paymentType) {
        return null;
    }

    return paymentType;
};
